export class DeleteDiagnosticFilterValueCommand {
  constructor(public payload: { diagnosticCodi: string }) {}
}
